import Signal from '../Signal'
import Keyboard from '../Keyboard'
import Wheel from '../Wheel'
import Touch from '../Touch'

export default class ScrollSlide
{
    constructor({
        parent = document.documentElement,
        container = document.body,
        getContent = () => document.body.querySelector('body>*'),
        keyboardEnabled = true
    } = {})
    {
        this.container = container
        this.parent = parent
        this.getContent = getContent

        this.keyboardEnabled = keyboardEnabled

        this.initProperties()
        this.bindMethods()
        this.initEvents()
    }


    //          INITIALIZE

    bindMethods()
    {
        this.previousForce = this.previousForce.bind(this)
        this.nextForce = this.nextForce.bind(this)
        this.previous = this.previous.bind(this)
        this.next = this.next.bind(this)
        this.refresh = this.refresh.bind(this)
        this.resize = this.resize.bind(this)
        this.scroll = this.scroll.bind(this)
    }

    initProperties()
    {
        this.isScrollTopOK = true
        this.isScrollBottomOK = true
        this.containerSize = [ 640, 360 ]
    }

    initEvents()
    {
        if (this.keyboardEnabled)
        {
            this.keyboard = new Keyboard()
            this.keyboard.onUp('ArrowUp', this.previousForce)
            this.keyboard.onUp('ArrowDown', this.nextForce)
            this.keyboard.onUp('Home', this.previousForce)
            this.keyboard.onUp('End', this.nextForce)
            this.keyboard.onUp('PageUp', this.previousForce)
            this.keyboard.onUp('PageDown', this.nextForce)
        }

        this.wheel = new Wheel({
            el: this.parent,
            onTop: this.previous,
            onDown: this.next,
            onStart: this.refresh
        })

        this.touch = new Touch({
            onDown: this.next,
            onTop: this.previous
        })

        this.onToTop = new Signal()
        this.onToBottom = new Signal()

        this.container.addEventListener('scroll', this.scroll)
    }


    //          METHODS

    scroll()
    {
        clearTimeout(this._scrollTO)
        this._scrollTO = setTimeout(this.refresh, 300)
    }

    resize(width, height)
    {
        this.containerSize = [ width, height ]
        this.refresh()
    }

    refresh()
    {
        const content = this.getContent()
        if (content && this.container)
        {
            this.isScrollTopOK =
                content.scrollHeight <= this.containerSize[1]
                || this.container.scrollTop <= 0

            this.isScrollBottomOk =
                content.scrollHeight <= this.containerSize[1]
                || this.container.scrollTop + this.containerSize[1] >= this.container.scrollHeight
        }
    }

    previousForce()
    {
        this.onToTop.dispatch()
    }

    nextForce()
    {
        this.onToBottom.dispatch()
    }

    previous()
    {
        if (this.isScrollTopOK)
        {
            this.previousForce()
        }
    }

    next()
    {
        if (this.isScrollBottomOk)
        {
            this.nextForce()
        }
    }


    //          REMOVE

    dispose()
    {
        this.disposeEvents()
    }

    disposeEvents()
    {
        if (this.keyboard)
        {
            this.keyboard.dispose()
        }

        this.wheel.dispose()
        this.touch.dispose()

        this.onToTop.removeAll()
        this.onToBottom.removeAll()

        this.container.removeEventListener('scroll', this.scroll)
    }
}
